<div class="flex flex-col flex-1 h-full items-center justify-center text-center gap-8 px-4">
  <img src="../../../../../assets/images/svg/bank-connection-ok.svg" class="w-[72px] h-auto" alt="" />
  <div class="flex flex-col gap-4">
    <p class="font-bold text-base text-secondary">{{ 'authentication_succeeded' | translate }}</p>
    <p class="text-sm text-secondary">{{ 'journey_continues_where_your_bank_sent_you' | translate }}</p>
  </div>
</div>
